// 配置信息
let time = Date.parse(new Date());
let platform = 'PC'
let version = '1.0'
// api请求前缀
const show = 'left'
const code = '000'   //请求成功的状态码
const navRight = '/pages/search/search'
const getData = `time=${time}&platform=${platform}&version=${version}`

export default {
	show,
	navRight,
	getData,
	code
}